<template>

  <div>

    <role-list-add-new
      :is-add-new-role-sidebar-active.sync="isAddNewRoleSidebarActive"
      :role-options="roleOptions"
      :plan-options="planOptions"
      :role="role"
      @refetch-data="refetchData"
      @add-role="addRole"
      @update-role="updateRole"
      :clear-role-data="resetRoleData"
    />
    <b-card
      no-body
      class="mb-0"
    >
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Нэг хуудсанд</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label> бичлэг харуулах</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Хайх..."
              />
              <b-button
                variant="primary"
                @click="isAddNewRoleSidebarActive = true"
              >
                <span class="text-nowrap">Үүрэг нэмэх</span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>
      <b-table
        ref="roleListTable"
        class="position-relative"
        :items="fetchRoles"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >

        <!-- Column: Organization -->
        <template #cell(organization)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="32"
                :src="data.item.avatar"
                :text="avatarText(data.item.fullName)"
                :variant="`light-${resolveOrganizationRoleVariant(data.item.role)}`"
                :to="{ name: 'ref-statuses-view', params: { id: data.item.id } }"
              />
            </template>
            <b-link
              :to="{ name: 'ref-statuses-view', params: { id: data.item.id } }"
              class="font-weight-bold d-block text-nowrap"
            >
              {{ data.item.fullName }}
            </b-link>
            <small class="text-muted">@{{ data.item.organizationname }}</small>
          </b-media>
        </template>

        <!-- Column: Role -->
        <template #cell(role)="data">
          <div class="text-nowrap">
            <feather-icon
              :icon="resolveOrganizationRoleIcon(data.item.role)"
              size="18"
              class="mr-50"
              :class="`text-${resolveOrganizationRoleVariant(data.item.role)}`"
            />
            <span class="align-text-top text-capitalize">{{ data.item.role }}</span>
          </div>
        </template>

        <!-- Column: Status -->
        <template #cell(status)="data">
          <b-badge
            pill
            :variant="`light-${resolveOrganizationStatusVariant(data.item.status)}`"
            class="text-capitalize"
          >
            {{ data.item.status }}
          </b-badge>
        </template>

        <!-- Column: is_active -->
        <template #cell(is_active)="data">
          <b-badge
            pill
            :variant="data.item.is_active ? 'success': 'danger'"
          >
            {{ data.item.is_active ? 'идэвхтэй': 'идэвхгүй' }}
          </b-badge>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-primary"
              class="btn-icon __table_action_button"
              @click="getRole(data.item)" v-b-tooltip.hover.v-primary title="Дэлгэрэнгүй"
              size="sm"
            >
              <feather-icon icon="FileTextIcon" />
            </b-button>
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-primary"
              class="btn-icon __table_action_button"
              @click="getRole(data.item)" v-b-tooltip.hover.v-primary title="Засах"
              size="sm"
            >
              <feather-icon icon="EditIcon" />
            </b-button>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Нийт {{ dataMeta.of }}-н {{ dataMeta.from }} - {{ dataMeta.to }} бичлэгийг  харуулж байна</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination, VBTooltip,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import RolesListFilters from './RolesListFilters.vue'
import useRolesList from './useRolesList'
import RoleStoreModule from '../RoleStoreModule'
import RoleListAddNew from './RoleListAddNew.vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    RolesListFilters,
    RoleListAddNew,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,

    vSelect,
  },
  directives: {
        'b-tooltip': VBTooltip,
        Ripple,
    },
  setup() {
    const ROLE_APP_STORE_MODULE_NAME = 'app-role'

    // Register module
    if (!store.hasModule(ROLE_APP_STORE_MODULE_NAME)) store.registerModule(ROLE_APP_STORE_MODULE_NAME, RoleStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(ROLE_APP_STORE_MODULE_NAME)) store.unregisterModule(ROLE_APP_STORE_MODULE_NAME)
    })

    const isAddNewRoleSidebarActive = ref(false)

    const blankRole = {
      name: '',
      sort_order: '',
    }

    const role = ref(JSON.parse(JSON.stringify(blankRole)))
    const resetRoleData = () => {
      role.value = JSON.parse(JSON.stringify(blankRole))
    }

    const roleOptions = [
      { label: 'Админ', value: 'admin' },
      { label: 'Эрхлэгч', value: 'author' },
      { label: 'Засварлагч', value: 'editor' },
      { label: 'Дэмжигч', value: 'maintainer' },
      { label: 'Дагагч', value: 'subscriber' },
    ]

    const planOptions = [
      { label: 'Үндсэн', value: 'basic' },
      { label: 'Дэд', value: 'company1' },
      { label: 'Аж ахуй нэгж', value: 'enterprise' },
      { label: 'Баг', value: 'team' },
    ]

    const statusOptions = [
      // { label: 'Хүлээгдэж буй', value: 'pending' },
      { label: 'Идэвхитэй', value: 'true' },
      { label: 'Идэвхигүй', value: 'false' },
    ]

    const addRole = val => {
      console.log('val', val)
      store.dispatch('app-role/addRole', val)
        .then(() => {
          // eslint-disable-next-line no-use-before-define
          // fetchRefPriorities()
          refetchData()
        })
    }

    const updateRole = val => {
      store.dispatch('app-role/editRole', val)
        .then(() => {
          refetchData()
        })
    }
    
    // const removeRefStatus = () => {
    //   store.dispatch('app-todo/removeTask', { id: task.value.id })
    //     .then(() => {
    //       // eslint-disable-next-line no-use-before-define
    //       fetchTasks()
    //     })
    // }

    const getRole = roleData => {
      console.log(roleData)
      role.value = roleData
      isAddNewRoleSidebarActive.value = true
    }

    const {
      fetchRoles,
      tableColumns,
      perPage,
      currentPage,
      totalOrganizations,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      roleListTable,
      refetchData,

      // UI
      resolveOrganizationRoleVariant,
      resolveOrganizationRoleIcon,
      resolveOrganizationStatusVariant,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
    } = useRolesList()

    

    return {

      // Sidebar
      isAddNewRoleSidebarActive,

      fetchRoles,
      tableColumns,
      perPage,
      currentPage,
      totalOrganizations,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      roleListTable,
      refetchData,

      addRole,
      updateRole,

      // getPriority,
      resetRoleData,
      role,
      getRole,

      // Filter
      avatarText,

      // UI
      resolveOrganizationRoleVariant,
      resolveOrganizationRoleIcon,
      resolveOrganizationStatusVariant,

      roleOptions,
      planOptions,
      statusOptions,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
.__table_action_button {
  margin-right: 5px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
./useRolesList../RoleStoreModule